import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Alert, Box, Link, Paper, Typography, useMediaQuery, useTheme } from '@mui/material';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
//import WarningAmberIcon from "@mui/icons-material/WarningAmber";
//import { ProfileFormData, QuestionsForm, ProfileQuestionsFormProps } from '../wizard/QuestionsForm'
//import { HeaderContent } from '../../app/sharedcomponents';
import { useDispatch, useSelector } from 'react-redux';
//import { useAppSelector, useAppDispatch } from '../../app/hooks'
import { ShowDialogInterface, showProfile } from "../../features/dialogSlice";
//import Slide from '@mui/material/Slide';
//import { TransitionProps } from '@mui/material/transitions'
import { profileApi, useUpdateProfileMutation } from '../../features/profilesSlice';
import { getSearchStateFromPayload, getSearchByTerm, setCenter as setSearchCenter } from '../../features/searchSlice'
import { triggerUserMarkerClick } from '../markers/UserMarker';
//import { CircularProgressCentered } from '../../app/sharedcomponents'
import { ErrorMessageWithContext, ProfileFormData, StepType } from '../wizard/QuestionsForm'
//import { YesNo } from '../wizard/YesNo';
//import { store } from '../../app/store';
import { WizardDialog, UpdateStepArgsType } from '../wizard/WizardDialog';
//import { UserType } from './UserType'
import { AnythingToShare } from './AnythingToShare'
import { Location } from './Location'
//import { Communicate } from './Communicate';
import { ThankYou } from '../survey/ThankYou';
//import { useNavigate } from 'react-router-dom';
import { /*ReplaceStep,*/ ReplaceStepBySubTitle } from '../survey/SurveyWizard';

//import { generateAISummary, getProfileFromID, setCenter } from "../../features/dataProcessingSlice"
import { ReviewYourPin } from './ReviewYourPin';
//import { CircleNotifications } from '@mui/icons-material';
import { CircularProgressCentered } from '../../app/components/sharedcomponents';
import { aiAnalyticsApi, useGenerateAISummaryMutation } from '../../features/aiAnalytics';
import { generateAISummaryThunk, setPublicPinClicked } from '../../features/dataProcessingSlice';
import { useAuthProfile } from '../../app/hooks';
import { printError } from '../../app/utils';
import { Communicate } from './Communicate';
import { GetCountryTypeByLabelDefualtToUs } from '../../app/components/CountryCodes';
import { useUpdateCognitoUserPhoneMutation } from '../../features/oidcSlice';
import { CUSTOM_METHOD } from '../../app/auth/utils';
import { useNavigate, useParams } from 'react-router-dom';
import { formatPhone } from '../../app/auth/phoneEntryUtils';
import { UniversalErrorBoundary } from './WizardErrorBoundary';
import { PhoneVerificationData } from './SmsPhoneValidation';



interface UpdateSate {
  isSuccess: boolean | undefined,
  step: number | undefined,
  data: any
  profileDTO: any
  args: UpdateStepArgsType | undefined
}


const profileSteps: StepType[] = [{
  screen: <Location />,
  title: "My Pin",
  subTitle: 'What is your zipcode?',
},
// {
//   screen: <UserType />,
//   title: "My Pin",
//   subTitle: 'Are you a Warrior, a Caregiver or a Medical professional?',
// },
{
  screen: <AnythingToShare />,
  title: "My Pin",
  subTitle: "My Story",
  //buttonTitle: "Finish",
}, //
{
  screen: <Communicate />,
  title: "My Pin",
  subTitle: "Text to Patient Connect",
  //skipLink: 'Add Later'
  //buttonTitle: "Finish",
}, //
{
  screen: <ReviewYourPin />,
  title: "My Pin",
  subTitle: "Review your pin",
  buttonTitle: "Finish",
}, //

{
  screen: <><ThankYou shoowCheckMark={false} /> <ErrorMessageWithContext name="root.postSave" /></>,
  subTitle: "Thank you for adding/updating your pin!",
  subTitle2: "Now that you have added your pin, you can find patients similar to you, learn from their stories, and connect with them if you choose.",
  buttonTitle: "OK",

  noProgressBar: true, noBackArrow: true,
  showBottomRight: true,
  autoSizeDialog: true
}

  // {screen: <Communicate />,
  //   title: "Communication",
  //   subTitle: 'Would you be open to communicating with other Multiple Myeloma Warriors, caregivers or medical professionals?',
  // },
  // {screen: <YesNo fieldName='receive_emails' />,
  //   title: "Communication",
  //   subTitle: 'Do you want to receive emails about things happening in our community?',
  // }
  //'Questions'
];


// interface MapDialogProps extends SurveyDialogProps {
//   UpdateStep: (formData: any, step: number, methods: any) => any
//   updatedEffect: (isUpdatedState: any, methods: any) => void
// }




interface ProfileQuestionsDialogProps //extends ProfileQuestionsFormProps {
{
  loggedInUserProfile: any
  //onClose: () => void;
}


export const ProfileWizard1: React.FC = () => {
  const showProfileState: ShowDialogInterface = useSelector((state: any) => state.dialog.showProfile)
  //  showProfileState.screenTitle?  profileSteps.findIndex( step => step.title === showProfileState.screenTitle)  : 0

  //screen: "Review your pin", singleScreen: true }

  const { authStatus, profile: loggedInUserProfile, isLoading: isLoadingLoggedInUserProfile, isSuccess: isSuccessLoggedInUserProfile, isError: isErrorLoggedInUserProfile, error: errorLoggedInUserProfile, /*userAttributesStateStatus, */  authMethod, customAuth, sub } = useAuthProfile()
  const [lastFormLocatoin, setLastFormLocatoin] = useState({ zipCode: loggedInUserProfile?.zipcode, country: loggedInUserProfile?.country })
  //const [updateStepArgs, setUpdateStepArgs] = useState<UpdateStepArgsType | undefined>(undefined);
  const [stepIndex, setStepIndex] = useState(showProfileState.step ?? 0);
  const [wizardSteps, setWizardSteps] = useState(profileSteps);
  const dispatch = useDispatch<any>();// useAppDispatch()
  //const [isUpdated, setIsUpdated] = useState<UpdateSate>({isSuccess: false, step: undefined, data: undefined, profileDTO: undefined, args: undefined });
  const [UpdateProfile, { isLoading: isUpdating, isSuccess, isError, error, data: updatedFormData/*, reset*/, originalArgs }] = useUpdateProfileMutation()
  const [UpdateCognitoUserPhone, { isLoading: isUpdatingCognitoUserPhone, isSuccess: isSuccessCognitoUserPhone, isError: isErrorCognitoUserPhone, error: errorCognitoUserPhone, data: dataCognitoUserPhone/*, reset*/, originalArgs: originalArgsCognitoUserPhone }] = useUpdateCognitoUserPhoneMutation()
  const [generateAISummary,  /*{isLoading: isLoadingGenerateAISummary, isSuccess: isSuccessGenerateAISummary, isError: isErrorGenerateAISummary, error: errorGenerateAISummary }*/] = useGenerateAISummaryMutation()
  //const navigate = useNavigate()
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));


  // const {formData, sumbitAattribute, stepIndexUpdate, methods} = updateStepArgs ?? { }




  //const lastStep = updateStepArgs?.stepIndexUpdate?.stepIndex === wizardSteps.length - 1
  const isUpdatedRef = useRef<UpdateSate>({
    isSuccess: false,
    step: undefined,
    data: {},
    profileDTO: {},
    args: undefined
  })

  if (isLoadingLoggedInUserProfile)
    return null // loading state handled by WizardDialog's isLoading prop
  // 2. Handle Missing Data (Throw to Boundary)
  if (!loggedInUserProfile) {
    // This interrupts rendering and activates the parent ErrorBoundary
    throw new Error("Profile unavaialbe.");
  }
  // if (isSuccessLoggedInUserProfile) {
  //   throw new Error("TEST Profile unavaialbe.");
  // }


  const UpdateStep: (updateStepArgs: UpdateStepArgsType) => Promise<any> = async (updateStepArgs) => {
    //const {formData, sumbitAattribute, stepIndexUpdate, methods} = updateStepArgs ?? { }
    //function onSuccessZ
    const OnUpdateProfileSuccess: (updateRe: any) => void = (updateRet) => {
      if (loggedInUserProfile.id && updateStepArgs) {//if (isSuccess && loggedInUserProfile.id && updateStepArgs) {      
        const lastStep = stepIndex === wizardSteps.length - 1
        // no need since mutation will invalidate dispatch(aiAnalyticsApi.util.invalidateTags([{type: 'AiProfile', id: updatedFormData.updatedUser.id }]))
        console.log('ProfileWizard1 isSuccess', isSuccess)
        dispatch(profileApi.util.invalidateTags([{ type: 'Profile', id: loggedInUserProfile.id }]));
        //show profile — defer until thank-you dialog is dismissed
        // dispatch(setPublicPinClicked(loggedInUserProfile.id))
        if (updateRet.message?.toLowerCase().includes("key (phone)=")) {
          //  methods.setError('phone', { type: 'validate', message: `` });
          const phoneExtracted = /\(phone\)=\(\+1(.+?)\)/.exec(updateRet.message)?.[1] ?? '';
          methods.setError('root.postSave', { type: 'phone', message: phoneExtracted ? formatPhone(phoneExtracted) : '' });
          if (!lastStep) {
            setStepIndex((prevStepIndex) => prevStepIndex + 1)
          }
          return true
        }
        if (!lastStep) {
          setStepIndex((prevStepIndex) => prevStepIndex + 1)
          //IncrementStepIndex()
        }

        if (lastStep && !updateStepArgs?.sumbitAattribute) {
          dispatch(setPublicPinClicked(loggedInUserProfile.id))
          dispatch(showProfile(undefined))//close wizard
          // Center map on user's pin and trigger info window animation
          if (loggedInUserProfile.lat && loggedInUserProfile.lng) {
            dispatch(setSearchCenter({ lat: loggedInUserProfile.lat, lng: loggedInUserProfile.lng }))
          }
          setTimeout(() => {
            if (triggerUserMarkerClick) {
              triggerUserMarkerClick()
            }
          }, 500)
        }
      }
    }//}, [isSuccess, dispatch, loggedInUserProfile?.id, updateStepArgs, updateStepArgs?.sumbitAattribute])
    //function onError
    const onError: (error: any) => void = (error) => {
      //if (isError) {
      console.log('Profile Wizard Update Error', error)
      const printedError = printError(error).toLocaleLowerCase()
      if (printedError.includes("name_public")) {
        methods.setError('name_public', { type: 'validate', message: `Username ${originalArgs?.profileDTO?.name_public} is already taken` });
      } else if (printedError.includes("used to log in")) {
        methods.setError('root.serverError', { type: 'validate', message: printedError });
      } else {
        methods.setError('root.serverError', { type: '400', message: "Oops... Could not update profile, please try later" });
      }
      return false
      //}
    }//, [isError])


    const updateProfileUTriggerUIUpdates: () => Promise<void> = async () => {
      var lastStep = stepIndex === wizardSteps.length - 1
      if (!sumbitAattribute && stepIndexUpdate?.steps[stepIndexUpdate.stepIndex].subTitle === "Review your pin") {
        if (Object.entries(methods?.formState?.dirtyFields ?? {}).length > 0) {
          const { status, ...noStatusProfileDTO } = (isUpdatedRef.current.profileDTO ?? {}) as Record<string, any>;//  const {status, ...noStatusProfileDTO } = isUpdated.profileDTO ?? { }
          const { location, ...noLocationData } = (isUpdatedRef.current.data ?? {}) as Record<string, any>;// const {location, ...noLocationData } = isUpdated.data ?? { }
          const defaultedCountryValue = GetCountryTypeByLabelDefualtToUs(location?.country ?? location?.country ?? '')
          // const profileDTOforUpdate = {
          //   ...noLocationData, ...location, ...noLocationData, /*...noLocationFormData, ...locationFormData, */...noStatusProfileDTO,
          //   ...(location?.zipCode && location?.country) ? { isCompleted: true } : {},
          //   ...noLocationData.phone?.phone ? { phone: `+${defaultedCountryValue?.phone}${noLocationData.phone.phone.replaceAll('(', '').replaceAll(')', '').replaceAll(' ', '').replaceAll('-', '')}` } : {}
          // }
          const { phone: phoneData, ...noPhoneLocationData } = noLocationData;
          
          // Only save phone if user consented and it's a valid 10-digit number
          const phoneDigits = phoneData?.phone?.replaceAll('(', '').replaceAll(')', '').replaceAll(' ', '').replaceAll('-', '') || '';
          const isValidPhone = phoneDigits.length === 10;
          
          const profileDTOforUpdate = {
            ...noPhoneLocationData,
            ...location,
            ...noPhoneLocationData,
            ...noStatusProfileDTO,
            ...(location?.zipCode && location?.country) ? { isCompleted: true } : {},
            ...(phoneData?.consentChecked && isValidPhone ? { phone: `+${defaultedCountryValue?.phone}${phoneDigits}` } : {})
          }
          if (methods?.formState?.dirtyFields?.phone) {
            if (authMethod === CUSTOM_METHOD && profileDTOforUpdate.phone !== loggedInUserProfile?.phone) {
              throw "the phone number can not be updated, if used to log in"
            }

            // if (profileDTOforUpdate.phone && profileDTOforUpdate.phone !== loggedInUserProfile?.phone) {//customAuth.user.phone_number ){
            //   if (customAuth?.user?.phone_number) {
            //     customAuth.updateSessionPhone(profileDTOforUpdate.phone)
            //   }
            //   // Cogniton user is updated in UpdateProfile UpdateCognitoUserPhone({ sub: sub ?? 'unauthenticated', newPhone: profileDTOforUpdate.phone })
            // }
          }
          //try {
          const updateRet = await UpdateProfile({ id: loggedInUserProfile.id, profileDTO: { ...profileDTOforUpdate } }).unwrap()
          OnUpdateProfileSuccess(updateRet)
          //generateAISummary({id: profile.id, story: formData.comment })
          if (methods?.formState?.dirtyFields?.comment) {
            dispatch(generateAISummaryThunk({ id: loggedInUserProfile?.id, story: formData?.comment }))
          }
        }
      }
    }
    //////////End of updateProfileAndOtherStepStuff
    const { formData, sumbitAattribute, stepIndexUpdate, methods } = updateStepArgs
    const { dirtyFields } = methods.formState
    const lastStep = stepIndexUpdate.stepIndex === wizardSteps.length - 1


    if (!sumbitAattribute && stepIndexUpdate?.steps[stepIndexUpdate.stepIndex].subTitle === "Review your pin") {
      if (loggedInUserProfile?.is_completed || !(formData?.location.country && formData?.location.zipCode)) {
        //setWizardSteps((oldSteps: StepType[]) => {
        //   const {isNew, steps} = ReplaceStepBySubTitle(oldSteps, undefined, "Thank you for adding your pin!")
        //   return isNew ? steps : oldSteps
        // })

        const updateSteps = (oldSteps: StepType[]) => {
          const { isNew, steps } = ReplaceStepBySubTitle(oldSteps, undefined, "Thank you for adding your pin!")
          return isNew ? steps : oldSteps
        }
        const newSteps = updateSteps(profileSteps)
      }
    }

    try {
      if (Object.entries(dirtyFields).length > 0) {
        if (dirtyFields.location && (lastFormLocatoin.country !== formData.location.country || lastFormLocatoin.zipCode !== formData.location.zipCode)) {
          const ret = await dispatch(getSearchByTerm(`${formData.location.zipCode} ${formData.location.country}`))
          //dispatch(profileApi.util.invalidateTags(['ProfilePinData'])) // to update distances
          switch (ret.type) {
            case 'search/getSearchByTerm/fulfilled':
              setLastFormLocatoin(formData.location)
              const profileDTO = getSearchStateFromPayload(ret.payload)
              if (profileDTO.zipCode) {
                profileDTO.formattedsearchterm = profileDTO.formattedsearchterm.replace(profileDTO.zipCode, '').replace('  ', ' ').replace(' ,', ',').trim()
                //formData.location.zipCode = formData.location.zipCode.replace(profileDTO.zipCode, '').replace('  ', ' ').replace(' ,', ',').trim()
              }
              profileDTO.zipCode = formData.location.zipCode //could contain city, town, etc
              //setIsUpdated({...isUpdated, isSuccess: true, step: stepIndexUpdate.stepIndex, data: formData, profileDTO: profileDTO })
              isUpdatedRef.current = { ...isUpdatedRef.current, isSuccess: true, step: stepIndexUpdate.stepIndex, data: formData, profileDTO: profileDTO }
              break;
            default:
              //methods.setError('submit', {type: 'manual', message: "Error finding location on map" });
              methods.setError('root.serverError', { type: '400', message: "Error finding location on map" });
              return false;
          }
        } else {
          //setIsUpdated({ ...isUpdated, isSuccess: true, step: stepIndexUpdate.stepIndex, data: { ...isUpdated.data, ...formData } })
          isUpdatedRef.current = {
            ...isUpdatedRef.current, isSuccess: true, step: stepIndexUpdate.stepIndex, data: { ...isUpdatedRef.current.data, ...formData }
          }

        }
        await updateProfileUTriggerUIUpdates()
      }
      ////////////////////////////Setting STEPS
      switch (sumbitAattribute) {
        case 'edit-story':
          setStepIndex(1)
          return
        case 'edit-personal-info':
          setStepIndex(0)
          return
        default:
          if (!lastStep) {
            //setStepIndex(stepIndex + 1)
          }
      }
      // Check if phone verification is needed before advancing (only on communication step)
      if (stepIndexUpdate?.steps[stepIndexUpdate.stepIndex].subTitle === "Text to Patient Connect") {
        const phoneData = formData?.phone;
        if (phoneData?.consentChecked && !phoneData?.verificationComplete) {
          // Don't advance - let nextPressed trigger SMS verification
          return false;
        }
      }

      //if (isUpdated?.step !== undefined) {
      if (stepIndexUpdate.stepIndex !== undefined) {
        if (lastStep) {
          dispatch(showProfile(undefined))//close wizard
          // Center map on user's pin and trigger info window animation
          if (loggedInUserProfile.lat && loggedInUserProfile.lng) {
            dispatch(setSearchCenter({ lat: loggedInUserProfile.lat, lng: loggedInUserProfile.lng }))
          }
          setTimeout(() => {
            if (triggerUserMarkerClick) {
              triggerUserMarkerClick()
            }
          }, 500)
        } else {
          setStepIndex(stepIndex + 1)
        }
      }

      //setIsUpdated({...isUpdated, step: stepIndexUpdate.stepIndex })
      isUpdatedRef.current = { ...isUpdatedRef.current, step: stepIndexUpdate.stepIndex }
    } catch (err) {
      // Catch runtime errors or network errors that throw
      console.error(err);
      //methods.setError('root.serverError', {type: '500', message: "Unexpected error finding location" });
      return onError(err)
      return false;
    }




  }

  const handleBack = () => {
    if (stepIndex > 0) {
      setStepIndex(stepIndex - 1); // Go back a step
    } else {
      //onClose(); // Close the dialog if already at the initial step
      //onCloseLocal()
      dispatch(showProfile(undefined))
    }
  };

  if (!loggedInUserProfile) {
    return null
  }

  //const isProfileForced = true
  const { zipCode, country, ...profileWithoutLocation } = loggedInUserProfile ?? {};

  const profileWithLocation: ProfileFormData = {
    ...profileWithoutLocation,
    location: { zipCode: loggedInUserProfile?.zipcode, country: loggedInUserProfile?.country },

  }

  const defaultPhoneValue: PhoneVerificationData = {
    phone: profileWithoutLocation.phone ?? '',
    verificationComplete: !!profileWithoutLocation.phone,
    consentChecked: profileWithLocation.communicate_by_messenger,
  }
  const defaultValues = {
    location: profileWithLocation?.location?.country ? profileWithLocation?.location : {
      ...profileWithLocation?.location ?? { zipCode: null },
      country: 'United States'
    },
    phone: defaultPhoneValue,
  }
  return (<>
    <WizardDialog
      sx={{
        '& .MuiDialog-paper': {
          width: isSmallScreen ? '95vw' : '520px',
          maxWidth: isSmallScreen ? '95vw' : '520px',
          maxHeight: isSmallScreen ? '90vh' : '80vh',
          m: isSmallScreen ? 1 : 'auto',
        },
      }}
      isLoading={isLoadingLoggedInUserProfile}
      isUpdating={isUpdating}
      steps={wizardSteps}
      open={showProfileState ? true : false}
      onClose={() => {
        setStepIndex(0)
        dispatch(showProfile(undefined))
      }}
      defaultFormDataformData={defaultValues}
      formData={profileWithLocation}
      wizardData={showProfileState}
      updatedData={isUpdatedRef.current}
      handleBack={handleBack}
      handleSkip={(methods: any) => {
        setStepIndex(stepIndex + 1)
        methods.clearErrors()
      }}
      updateStep={UpdateStep}
      stepIndex={stepIndex} />
  </>
  )

}

//export const ProfileWizard = React.memo(ProfileWizard1);  // useEffect(() => {
export const ProfileWizard: React.FC = () => {
  const dispatch = useDispatch();
  return (
    <UniversalErrorBoundary
      displayVariant="dialog" // <--- Selects Popup mode
      onClose={() => dispatch(showProfile(undefined))}>
      <ProfileWizard1 />
    </UniversalErrorBoundary>
  );
};



export const ExistingPhoneAccountNotice: React.FC<{ message?: string, navigateTo?: string }> = ({ navigateTo, message }) => {
  const navigate = useNavigate();
  const phoneMessage = `We couldn’t link the phone number ${formatPhone(message ?? '')} because it’s already connected to another account`
  const dispatch = useDispatch<any>();//
  return (
    <Paper
      elevation={0}
      sx={{
        p: 1.5,
        mt: 1.5,
        borderRadius: 2,
        bgcolor: "rgba(101, 110, 255, 0.06)",
        border: "1px solid rgba(164, 142, 233, 0.15)",
        display: "flex",
        alignItems: "flex-start",
        gap: 1,
      }}
    >
      <InfoOutlinedIcon
        sx={{ fontSize: 20, color: "#656EFF", mt: "1px", flexShrink: 0 }}
      />
      <Box>
        <Typography variant="caption" sx={{ color: "#555", lineHeight: 1.5, display: "block" }}>
          {phoneMessage}. No worries - we{"’"}re happy to help get this sorted.
        </Typography>
        <Box sx={{ my: 0.75, textAlign: "center" }}>
          <Link component="button" variant="caption"
            onClick={(event: React.MouseEvent) => {
              event.preventDefault();
              navigate("/Contact/?message=" + encodeURIComponent("Hi - I got this message: " + phoneMessage + ", while linking a phone number to my account"))
              dispatch(showProfile(undefined))
            }}
            sx={{ fontWeight: 600, color: "#656EFF" }}
          >
            contact@polygonhealth.com
          </Link>
        </Box>
        <Typography variant="caption" sx={{ color: "#555", lineHeight: 1.5, display: "block" }}>
          Our team will get in touch to resolve this for you as quickly as possible.
        </Typography>
      </Box>
    </Paper>
  );
};



